import { AudioPlayerState } from '@hts/shared/types';
import { create } from 'zustand';

export const useAudioPlayerStore = create<AudioPlayerState>((set, get) => ({
  activeSongId: undefined,
  audioElement: null,
  tracks: new Map(),

  setActiveSong: (id) => {
    const { audioElement } = get();

    if (audioElement) {
      if (id === undefined) {
        audioElement.pause();
      } else {
        const track = get().tracks.get(id);

        if (track) {
          audioElement.currentTime = track.currentTime;
        }
      }
    }

    set({ activeSongId: id });
  },

  setAudioElement: (element) => {
    set({ audioElement: element });
  },

  updateTrackTime: (songId, currentTime) => {
    const { tracks } = get();
    const track = tracks.get(songId);

    if (track) {
      tracks.set(songId, {
        ...track,
        currentTime,
        lastUpdate: Date.now(),
      });
      set({ tracks: new Map(tracks) });
    }
  },

  updateTrackDuration: (songId, duration) => {
    const { tracks } = get();
    const track = tracks.get(songId);

    if (track) {
      tracks.set(songId, {
        ...track,
        duration,
      });
      set({ tracks: new Map(tracks) });
    }
  },

  setTrackVisibility: (songId, isVisible) => {
    const { tracks } = get();
    const track = tracks.get(songId);

    if (track) {
      tracks.set(songId, {
        ...track,
        isVisible,
      });
      set({ tracks: new Map(tracks) });
    } else if (isVisible) {
      tracks.set(songId, {
        currentTime: 0,
        duration: 0,
        isVisible: true,
        lastUpdate: Date.now(),
      });
      set({ tracks: new Map(tracks) });
    }
  },

  removeTrack: (songId) => {
    const { tracks } = get();
    tracks.delete(songId);
    set({ tracks: new Map(tracks) });
  },
}));
